let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cWVaN")).then(() => parcelRequire('2tzo9'));